import { Route } from "../../../security/route";
import AddTrainingPath from "../training-path/add-training-path/addTrainingPath";
import ModuleStarting from "../training-path/module/module-starting";
import TrainingPathCover from "../training-path/training-path-cover/trainingPathCover";
import TrainingPathEditor from "../training-path/training-path-editor/trainingPathEditor";
import ArchivedTrainingPathList from "../training-path/training-path-list/archivedTrainingPathList";
import TraingPathListDisplayType from "../training-path/training-path-list/traingPathListDisplayType";
import TrainingPathOverview from "../training-path/training-path-overview/trainingPathOverview";
import TrainingPathStatistics from "../training-path/training-path-statistics/trainingPathStatistics";

export const routes: Route[] = [
  {
    path: "/training-paths",
    children: [
      { path: "", Component: TraingPathListDisplayType, exact: true, roles: ["ROLE_ELEARNING_ADMIN", "ROLE_ELEARNING_USER"] },
      { path: "/archive", Component: ArchivedTrainingPathList, exact: true, roles: ["ROLE_ELEARNING_ADMIN"] },
      { path: "/add", Component: AddTrainingPath, exact: true, roles: ["ROLE_ELEARNING_ADMIN"] },
      { path: "/cover", Component: TrainingPathCover, exact: true, roles: ["ROLE_ELEARNING_ADMIN"] },
      { path: "/update/:id", Component: AddTrainingPath, exact: true, roles: ["ROLE_ELEARNING_ADMIN"] },
      { path: "/manage-overview/:id", Component: TrainingPathEditor, exact: true, roles: ["ROLE_ELEARNING_ADMIN"] },
      { path: "/overview/:id", Component: TrainingPathOverview, exact: true, roles: ["ROLE_ELEARNING_ADMIN", "ROLE_ELEARNING_USER"] },
      { path: "/statistics", Component: TrainingPathStatistics, exact: true, roles: ["ROLE_ELEARNING_ADMIN"] },
      { path: "/starting-modules/:id", Component: ModuleStarting, exact: true, roles: ["ROLE_ELEARNING_USER"] },
    ],
  },
];
